import React from 'react';
import {makeStyles} from '@mui/styles';
import {Box, Grid, Typography} from '@mui/material';
import {openFullScreenVideo} from '../../util/VideoHelpers';
import {useHistory} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {userState} from '../../recoil/user/userAtom';
import {theme} from '../../Theme';
import TertiaryButton from '../../common/StyledComponents/TertiaryButton';

const homeownerOptions = [
  {
    color: theme.palette.pink.main,
    title: 'How to post a project',
    video: 'creating_a_project',
    id: 'creating_a_project',
  },
  {
    color: theme.palette.purple.main,
    title: 'How to host a site visit',
    video: 'onboarding_site_visits',
    id: 'site_visits',
  },
  {
    color: theme.palette.blue.main,
    title: 'How to review and award a bid',
    video: 'accept_bid',
    id: 'accept_bid',
  },
  {
    color: theme.palette.green.main,
    title: "About Bidmii's secure payment process",
    video: 'pay_securely',
    id: 'pay_securely',
  },
];

const contractorOptions = [
  {
    color: theme.palette.pink.main,
    title: 'How to set up your profile',
    video: 'profile_setup',
    id: 'profile_setup',
  },
  {
    color: theme.palette.purple.main,
    title: 'How to find jobs',
    video: 'browsing_jobs',
    id: 'browsing_jobs',
  },
  {
    color: theme.palette.blue.main,
    title: 'How to create and post a bid',
    video: 'creating_a_proposal',
    id: 'creating_a_proposal',
  },
  {
    color: theme.palette.green.main,
    title: 'How to get paid quickly and securely',
    video: 'requesting_completion',
    id: 'requesting_completion',
  },
];

const useStyles = makeStyles(() => ({
  videoBox: {
    border: `1px solid ${theme.palette.gray.border}`,
    borderRadius: 5,
    cursor: 'pointer',

    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function SupportOptions(props: $TSFixMe) {
  const classes = useStyles();
  const history = useHistory();
  const user = useRecoilValue(userState);

  const userType = props.userType || user?.userType || 'REQUESTER';

  const supportOptions =
    userType === 'BIDDER' ? contractorOptions : homeownerOptions;

  const handleClickFAQ = () => {
    props.toggleSupport && props.toggleSupport();
    history.push(`FAQ?userType=${userType}`);
  };

  const handleClickChat = () => {
    props.toggleSupport && props.toggleSupport();
    (window as $TSFixMe)._chatlio.showOrHide();
  };

  const supportButton = (text: $TSFixMe, onClick: $TSFixMe) => (
    <TertiaryButton onClick={onClick}>
      <Typography
        variant="subtitle1"
        style={{textTransform: 'none', lineHeight: 1.1}}>
        {text}
      </Typography>
    </TertiaryButton>
  );

  return (
    <Grid container direction="column">
      <Typography variant="body1" style={{fontSize: 22}}>
        How can we help you?
      </Typography>
      <Box my={2.5}>
        <Typography variant="subtitle1">GETTING STARTED</Typography>
        {supportOptions.map((option) => (
          <Box
            key={option.id}
            p={1.5}
            mb={0.5}
            className={classes.videoBox}
            style={{
              maxHeight:
                window.outerWidth <= 400 && option.id === 'pay_securely'
                  ? 64
                  : 50,
            }}
            onClick={() =>
              openFullScreenVideo(
                option.id,
                `https://cdn.bidmii.com/media/${option.video}.mp4`,
              )
            }>
            <Grid container alignItems="center" style={{flexWrap: 'nowrap'}}>
              <div
                style={{
                  width: 10,
                  height: 9,
                  marginRight: 8,
                  borderRadius: '50%',
                  backgroundColor: option.color,
                }}
              />
              <Typography
                variant="subtitle2"
                style={{color: theme.palette.gray.dark}}>
                {option.title}
              </Typography>
            </Grid>
            <video
              src={`https://cdn.bidmii.com/media/${option.video}.mp4`}
              id={option.id}
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; src: string; id: string;... Remove this comment to see the full error message
              alt={option.title}
              controls
              style={{height: 0}}>
              Sorry, your browser doesn't support embedded videos
            </video>
          </Box>
        ))}
      </Box>
      <Typography variant="subtitle1" gutterBottom>
        STILL HAVE QUESTIONS?
      </Typography>
      <Typography variant="subtitle1" color="textSecondary">
        Visit our {supportButton('FAQ page', handleClickFAQ)} or{' '}
        {supportButton('chat directly', handleClickChat)} with a member of our
        customer success team.
      </Typography>
    </Grid>
  );
}
